import { computed, inject, Injectable } from '@angular/core';
import { UserStateService } from './user-state.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  private readonly userState = inject(UserStateService);

  readonly _permissionSet = computed(
    () => new Set(this.userState.permissions().map(p => p.permission))
  );

  has(...perms: string[]): boolean {
    if (!perms.length) return true;
    return perms.some(p => this._permissionSet().has(p));
  }

  hasAll(...perms: string[]): boolean {
    return perms.every(p => this._permissionSet().has(p));
  }
}
